// import Vue from 'vue';
import { inject, prop, Bus, Subscription, ViewRouterLocationChanged, ComponentEventBus } from "fw";

import offset from "document-offset";

const getScrollY = () =>
    window.pageYOffset !== undefined ? window.pageYOffset : ((document.documentElement || document.body.parentNode || document.body) as HTMLElement).scrollTop;

@inject
export class Popover {
    @prop(false) fixed: boolean;
    @prop(false) open: boolean;
    private $refs: {
        popover: HTMLElement;
    };

    p_isOpen = false;
    openClass = false;

    routerSub: Subscription = null;

    constructor(
        private bus: Bus,
        private ceb: ComponentEventBus
    ) {}

    created() {
        this.routerSub = this.bus.subscribe(ViewRouterLocationChanged, () => {
            this.clickOutside();
        });
    }

    destroyed() {
        this.routerSub.dispose();
    }

    main: HTMLElement;

    openChanged() {
        if (this.open === false) {
            this.close();
        }
    }

    get isOpen() {
        return this.p_isOpen;
    }

    set isOpen(val: boolean) {
        this.p_isOpen = val;
        this.ceb.dispatch("update:open", val);
    }

    click() {
        const element = this.main;
        const { offsetHeight } = element;
        const { top } = offset(element);

        let { left: x } = offset(element);

        let y = top + (offsetHeight || 0);
        if (this.fixed) {
            y -= getScrollY();
        }

        if (!this.isOpen) {
            this.isOpen = true;

            (this as any).$nextTick(() => {
                (this as any).$nextTick(() => {
                    const popoverElement = this.$refs.popover;
                    const popoverWidth = popoverElement.clientWidth;
                    const popoverHeight = popoverElement.clientHeight;

                    const { innerWidth: viewPortWidth, innerHeight: viewPortHeight } = window;

                    const scrollY = getScrollY();

                    if (x + popoverWidth > viewPortWidth) {
                        x = viewPortWidth - popoverWidth - 20;
                    } else {
                        x = Math.max(x, 20);
                    }

                    if (y + popoverHeight > viewPortHeight + scrollY) {
                        y = viewPortHeight - popoverHeight - 20 + scrollY;
                    }

                    popoverElement.style.left = `${x}px`;
                    popoverElement.style.top = `${y}px`;
                    popoverElement.style.position = this.fixed ? "fixed" : null;
                    popoverElement.focus();
                    this.openClass = true;
                });
            });
        } else {
            this.close();
        }
    }

    close() {
        this.openClass = false;
        setTimeout(() => {
            this.main.focus();
            this.isOpen = false;
        }, 300);
    }

    clickOutside() {
        if (this.isOpen) this.close();
    }
}
